import React, { useState, useEffect, useRef } from "react";
import clientConfig from "../../client-config";
import PortableText from "./portableText";
import * as styles from './fullWidthBanner.module.css';
import { gsap, TweenMax, Expo } from "gsap";

function fullWidthBanner(props) {

    const sectionRef = useRef();
    const titleRef = useRef();
    const contentRef = useRef();
    const circleLeftRef = useRef();
    const circleRightRef = useRef();

    useEffect(() => {
        
        let isInViewport = (ins, os) => {
            let offset = (os) ? os : 0;
            if(ins.offset()){
                let elementTop = ins.offset().top + 10 - offset;
                let elementBottom = elementTop + ins.outerHeight() - offset;
                let viewportTop = $(window).scrollTop();
                let viewportBottom = viewportTop + $(window).height();
                return elementBottom > viewportTop && elementTop < viewportBottom;
            }
            return false;
        }

        // TweenMax.set([titleRef.current, contentRef.current], {
        //     opacity: 0,
        //     y: 80
        // });
        if(!$(sectionRef.current).hasClass('anim-complete')){
            $(window).on('scroll', () => {
                if(isInViewport($(sectionRef.current), (0-($(window).height()/4)) )){
                    // TweenMax.to(
                    //     titleRef.current, 
                    //     0.45, 
                    //     { 
                    //         opacity: 1, 
                    //         y: 0, 
                    //         delay : 0.25
                    //     } 
                    // );

                    // TweenMax.to(
                    //     contentRef.current, 
                    //     0.45, 
                    //     { 
                    //         opacity: 1, 
                    //         y: 0, 
                    //         delay : 0.45,
                    //         onComplete : () => {
                    //             $(sectionRef.current).addClass('anim-complete');
                    //         }
                    //     } 
                    // );
                    
                }

                $(sectionRef.current).addClass('anim-complete');
                
                let scroll_factor = 4;
                let scroll_factor_alt = 6;
                let scroll_limit = 85;
                let ref_offset = $(sectionRef.current).offset();
                let scroll_pos = $(window).scrollTop();

                if(ref_offset){
                    if(scroll_pos > (ref_offset.top - $(window).height()) ){
                        let move_by = ((scroll_pos - ref_offset.top) / scroll_factor);
                        move_by = (move_by >= scroll_limit) ? scroll_limit : move_by;

                        TweenMax.to(circleLeftRef.current, 0.25, {
                            y : 0 - move_by
                        });

                        let move_by_alt = ((scroll_pos - ref_offset.top) / scroll_factor_alt);
                        move_by_alt = (move_by_alt >= scroll_limit) ? scroll_limit : move_by_alt;

                        TweenMax.to(circleRightRef.current, 0.25, {
                            y : 0 - move_by_alt
                        });
                    }
                }
            });
        }

    });

    
    // let bgImage = (props.bgimage) ? props.bgimage.image.asset.url : false;

    return (
        <div className={styles.sectionFullWidthBanner} ref={sectionRef}>

            <div className={styles.circleLeft} ref={circleLeftRef}></div>
            <div className={styles.circleRight} ref={circleRightRef}></div>

            <div className={styles.sectionContainer}>
                <h2 ref={titleRef}>{props.heading}</h2>
                <div ref={contentRef} className={styles.contentWrap}>
                    <PortableText blocks={props.content} />
                </div>
            </div>
        </div>
    );
}

export default fullWidthBanner;